import axios from "axios";
import { endpoints } from "../config/api";
import { getAuthHeaders } from "./getAuthHeaders";
import {
  buildDashboardsAdminParams,
  dashboardsAdminParamsSerializer,
  DASHBOARDS_ADMIN_MAX_LIMIT,
} from "./buildDashboardsAdminParams";

const dashboardAdminHeaders = () => ({
  ...getAuthHeaders(),
  Accept: "*/*",
  "Content-Type": "application/json",
});

export const fetchDashboardsAdminPage = async (queryOverrides = {}) => {
  const response = await axios.get(endpoints.agentsDashboardsAdmin, {
    params: buildDashboardsAdminParams(queryOverrides),
    paramsSerializer: dashboardsAdminParamsSerializer,
    headers: dashboardAdminHeaders(),
  });
  const body = response.data || {};
  const data = Array.isArray(body.data) ? body.data : [];
  const total = typeof body.total === "number" ? body.total : data.length;
  return { data, total };
};

export const fetchAllDashboardsAdmin = async (queryOverrides = {}) => {
  const collected = [];
  let currentPage = 1;
  let totalFromApi = null;

  while (true) {
    const { data: chunk, total } = await fetchDashboardsAdminPage({
      ...queryOverrides,
      page: currentPage,
      limit: DASHBOARDS_ADMIN_MAX_LIMIT,
    });
    collected.push(...chunk);
    totalFromApi = total;
    if (chunk.length === 0) break;
    if (totalFromApi != null && collected.length >= totalFromApi) break;
    if (chunk.length < DASHBOARDS_ADMIN_MAX_LIMIT) break;
    currentPage += 1;
  }

  return collected;
};
